import { render, staticRenderFns } from "./PosturasByIdLote.vue?vue&type=template&id=4334be45"
import script from "./PosturasByIdLote.vue?vue&type=script&lang=js"
export * from "./PosturasByIdLote.vue?vue&type=script&lang=js"
import style0 from "./PosturasByIdLote.vue?vue&type=style&index=0&id=4334be45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports